<div class="tds-footer">
  <tds-footer #tdsfooter>
  </tds-footer>
</div>
